import { useContext } from 'react';
import { configurationContext } from '../../contexts';
import { colors, consoleLog } from '../../utils';
import { AccordionMenuItem } from './AccordionMenuItem';
import { jsx as _jsx } from "react/jsx-runtime";
export var AccordionMenu = function AccordionMenu(_ref) {
  var menuItems = _ref.menuItems,
    menuClickedItem = _ref.menuClickedItem,
    onMenuClick = _ref.onMenuClick;
  var _useContext = useContext(configurationContext),
    isDev = _useContext.isDev;
  consoleLog(isDev, {
    ref: 'PersonalMenu',
    text: '--- RENDER Menu',
    color: colors.render
  });
  return /*#__PURE__*/_jsx("ul", {
    children: menuItems.map(function (item) {
      return /*#__PURE__*/_jsx(AccordionMenuItem, {
        menuItem: item,
        menuClickedItem: menuClickedItem,
        onMenuClick: onMenuClick
      }, "accordion-".concat(item.itemPath));
    })
  }, "theMenu");
};